import { Component, inject, input, output } from '@angular/core';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-apple-button',
  standalone: true,
  templateUrl: './apple-button.component.html',
  styleUrl: './apple-button.component.scss',
})
export class AppleButtonComponent {
  label = input.required<string>();
  btnClick = output<void>();

  readonly isDark = inject(ThemeService).isDark;
}
